// Shared vocabulary for a tool-call's `error` field, read by `withExecutorPolicy` and the
// capability-gap detector. `INTEGRATION_NOT_CONNECTED` carries the exact literal over a
// dozen tool files already return ad hoc (`const INTEGRATION_NOT_CONNECTED =
// 'integration_not_connected'`) — this enum is the one place those strings now come from;
// migrating those call sites is a separate slice.
export enum ToolErrorCode {
  INTEGRATION_NOT_CONNECTED = 'integration_not_connected',
  SOURCE_ACCOUNT_DISCONNECTED = 'source_account_disconnected',
  NOT_DOBOX_OWNER = 'not_dobox_owner',
  STALE_ENVELOPE = 'stale_envelope',
  CONFIRMATION_NOT_MATCHED = 'confirmation_not_matched',
  INVALID_TOOL_NAME = 'invalid_tool_name',
  UNVERIFIED_NEED = 'unverified_need',
  CAPABILITY_DECLINED = 'capability_declined',
  NO_COUNTERPART = 'no_counterpart',
  UNSUPPORTED_PLATFORM = 'unsupported_platform',
  GRANT_MISSING = 'grant_missing',
}

// A scope-gap error isn't one fixed code — it's per-integration
// (`drive_scope_not_granted`, `calendar_scope_not_granted`, …), so it can't be a ToolErrorCode
// member. This suffix is the shared contract every one of those literals already follows.
export const SCOPE_NOT_GRANTED_SUFFIX = '_scope_not_granted';

export const isScopeNotGrantedError = (code: string): boolean =>
  code.endsWith(SCOPE_NOT_GRANTED_SUFFIX);
